import { createFileRoute } from "@tanstack/react-router";
import { pageHead } from "@/lib/routeHead";
import PartnerWorkspacePage from "@/pages/partner/PartnerWorkspacePage";
export const Route = createFileRoute("/partner/submissions")({
  head: () =>
    pageHead(
      "Partner Submissions",
      "Your authorized Partner company workspace.",
      "/partner/submissions",
      true,
    ),
  component: () => <PartnerWorkspacePage section="submissions" />,
});
